module.exports = __webpack_public_path__ + "media/images/blup_mirror-7daed5e94afc87888b95a1ef0382d253.png";